module.exports = __webpack_public_path__ + "img/white.e7036f84.svg";